import React from "react"

import MyWishlistItem from "../MyWishlisItem"

import { SeparateLineBottom } from "../../utils/style"
import { WishlistItems, WithoutWishlist } from "./styles"

interface IMyWishlistItemsProps {
    wishlists: {
        name: string;
        products: {
            price: number

        }[];
        environment: string;
        linkId: string;
        createdAt: string;
        linkName?: string;
        code?: string;
    }[];
    loading: boolean;
    isEmpty: boolean;
}

const MyWishlistItems: React.FC<IMyWishlistItemsProps> = ({ wishlists, loading, isEmpty }) => {

    if (!loading && isEmpty) {
        return (
            <>
                <WithoutWishlist>Sem Lojinhas</WithoutWishlist>
                <SeparateLineBottom />
            </>
        )
    }

    const descendingOrderDate = (a: { createdAt: string }, b: { createdAt: string }) => {
        if (b.createdAt > a.createdAt) return 1;
        else { return -1 }
    }

    return (
        <WishlistItems>
            {
                wishlists.sort(descendingOrderDate).map((wishlist) => (
                    <MyWishlistItem key={wishlist.linkId}  {...wishlist} />
                ))
            }

        </WishlistItems>
    )
}

export default MyWishlistItems